/**
 * 我销售的比价列表
 */
export const PRICE_COMPARE_SALE_LIST_PAGE_PATH = '/priceCompare/list/sale'
